import React from 'react'
import { StepForm } from '../StepForm'
import styled from 'styled-components'
import { TextAreaForm } from 'spa/member/components/TextAreaForm'
import { RadioForm } from 'spa/member/components/RadioForm'
import { FormType } from '../types'

type Props = {
  formType: FormType
}

const StyledFormOuter = styled.div`
  > *:not(:last-child) {
    margin-bottom: 32px;
  }
`

export const StyledFourthForm: React.FC<Props> = (props) => {
  const workFromAbroadOptions = [
    { label: '国内(日本)で稼働予定', value: 'false' },
    { label: '国外(日本以外)で稼働予定', value: 'true' },
  ]

  return (
    <StepForm formType={props.formType} title="その他">
      <StyledFormOuter>
        <TextAreaForm
          name='excluded_companies'
          label='ご推薦を控えてほしい企業名があれば教えてください'
          annotationNote='※企業名が複数ある場合はカンマ区切りで入力してください'
          textAreaProps={{ placeholder: '株式会社○○○○、株式会社××' }}
          rules={{
            maxLength: {
              value: 1000,
              message: '1000文字以内で入力してください'
            }
          }}
          dataCy="excluded-companies"
        />
        <RadioForm
          name='work_from_abroad'
          label='稼働場所について'
          annotationNote={
            <>
              ※日本以外からご稼働いただく場合、クラウドワークス テックからお支払いする報酬は不課税になります<br />

              ※お振込口座は日本国内の銀行口座のみとなります（※Paypalは使用不可）
            </>
          }
          options={workFromAbroadOptions}
          required
          rules={{
            required: 'この質問は必須です'
          }}
          dataCy="work-from-abroad"
        />
      </StyledFormOuter>
    </StepForm>
  )
}
